module.exports = __webpack_public_path__ + "img/image 1.37446944.png";